import React, { useState, useEffect, useRef } from "react";
import { TimerIcon } from "../icons";
import "./timePicker.scss";

const padZero = (num) => (num < 10 ? `0${num}` : `${num}`);

const TimePicker = ({
  value = "",
  onChange = () => {},
  placeholder = "Select",
}) => {
  const [hour, setHour] = useState(12);
  const [minute, setMinute] = useState(0);
  const [amPm, setAmPm] = useState("AM");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Parse incoming value (e.g., "12:00 AM") on mount or when value changes.
  useEffect(() => {
    if (value) {
      console.log("TimePicker received value:", value);
      const [timePart, amPmPart] = value.split(" ");
      if (timePart && amPmPart) {
        const [h, m] = timePart.split(":");
        setHour(Number(h));
        setMinute(Number(m));
        setAmPm(amPmPart);
      }
    }
  }, [value]);

  const handleToggleDropdown = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    window.addEventListener("mousedown", handleClickOutside);
    return () => window.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const hours = Array.from({ length: 12 }, (_, i) => i + 1);
  const minutes = Array.from({ length: 60 }, (_, i) => i);

  const displayValue = value;

  const handleConfirm = () => {
    const newValue = `${hour}:${padZero(minute)} ${amPm}`;
    console.log("TimePicker confirming value:", newValue);
    onChange(newValue);
    setIsOpen(false);
  };

  const handleClear = (e) => {
    e.stopPropagation();
    console.log("TimePicker clearing value.");
    setHour(12);
    setMinute(0);
    setAmPm("AM");
    onChange("");
    setIsOpen(false);
  };

  return (
    <div className="custom-time-picker" ref={dropdownRef}>
      <div className="time-picker-input" onClick={handleToggleDropdown}>
        {displayValue ? (
          <div className="selected-value">
            <span>{displayValue}</span>
            <button className="clear-times-btn" onClick={handleClear}>
              Clear
            </button>
          </div>
        ) : (
          <div className="placeholder-with-icon">
            <TimerIcon
              fillColor="var(--color-yellowgold)"
              width="20"
              height="20"
            />
            <span>{placeholder}</span>
          </div>
        )}
      </div>
      {isOpen && (
        <div className="time-picker-dropdown">
          <div className="time-picker-column">
            {hours.map((h) => (
              <div
                key={`hour-${h}`}
                className={`time-picker-option ${h === hour ? "selected" : ""}`}
                onClick={() => {
                  console.log("TimePicker hour selected:", h);
                  setHour(h);
                }}
              >
                {h}
              </div>
            ))}
          </div>
          <div className="time-picker-column">
            {minutes.map((m) => (
              <div
                key={`minute-${m}`}
                className={`time-picker-option ${m === minute ? "selected" : ""}`}
                onClick={() => {
                  console.log("TimePicker minute selected:", m);
                  setMinute(m);
                }}
              >
                {padZero(m)}
              </div>
            ))}
          </div>
          <div className="time-picker-column">
            {["AM", "PM"].map((ampmVal) => (
              <div
                key={`ampm-${ampmVal}`}
                className={`time-picker-option ${ampmVal === amPm ? "selected" : ""}`}
                onClick={() => {
                  console.log("TimePicker AM/PM selected:", ampmVal);
                  setAmPm(ampmVal);
                }}
              >
                {ampmVal}
              </div>
            ))}
            <div className="time-picker-confirm">
              <button className="time-confirm-button" onClick={handleConfirm}>
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TimePicker;
